import posthog from 'posthog-js';
import { browser, dev } from '$app/environment';
import { inject } from '@vercel/analytics';
import type { LoadEvent } from '@sveltejs/kit';

// Initialize Vercel Analytics only in browser
export const load = async ({ url }: LoadEvent) => {
	if (browser) {
		// Initialize Vercel Analytics
		inject({ mode: dev ? 'development' : 'production' });
		
		// Initialize PostHog
		posthog.init('phc_4ol7tz263Y3vYiKgUX9PBZLivWIEHA6X2hNjEy3w7UB', {
			api_host: 'https://us.i.posthog.com',
			person_profiles: 'identified_only'
		});
	}

	return {
		url: url.pathname
	};
};
